var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeopleGroupSolidBlu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 640 451.7",
    style: {
      enableBackground: "new 0 0 640 451.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0079F2;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184,57.8c0,30.9-25.1,56-56,56s-56-25.1-56-56s25.1-56,56-56S184,26.9,184,57.8z M64,215.5  c-10,11.2-16,26.1-16,42.3s6,31.1,16,42.3V215.5z M208.4,166.2C178.7,192.5,160,231,160,273.8c0,34.3,12,65.8,32,90.5v21.5  c0,17.7-14.3,32-32,32H96c-17.7,0-32-14.3-32-32V359C26.2,341,0,302.5,0,257.8c0-61.9,50.1-112,112-112h32  C168,145.8,190.2,153.3,208.4,166.2L208.4,166.2z M448,385.8v-21.5c20-24.7,32-56.2,32-90.5c0-42.8-18.7-81.3-48.4-107.7  c18.2-12.8,40.4-20.3,64.4-20.3h32c61.9,0,112,50.1,112,112c0,44.7-26.2,83.2-64,101.2v26.8c0,17.7-14.3,32-32,32h-64  C462.3,417.8,448,403.5,448,385.8z M568,57.8c0,30.9-25.1,56-56,56s-56-25.1-56-56s25.1-56,56-56S568,26.9,568,57.8z M576,215.5  v84.7c10-11.3,16-26.1,16-42.3s-6-31.1-16-42.3V215.5z M320,129.8c-35.3,0-64-28.7-64-64s28.7-64,64-64s64,28.7,64,64  S355.3,129.8,320,129.8z M240,273.8c0,16.2,6,31,16,42.3v-84.6C246,242.8,240,257.6,240,273.8z M384,231.5v84.7  c10-11.3,16-26.1,16-42.3s-6-31.1-16-42.3V231.5z M448,273.8c0,44.7-26.2,83.2-64,101.2v42.8c0,17.7-14.3,32-32,32h-64  c-17.7,0-32-14.3-32-32V375c-37.8-18-64-56.5-64-101.2c0-61.9,50.1-112,112-112h32C397.9,161.8,448,211.9,448,273.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleGroupSolidBlu);
export default __webpack_public_path__ + "static/media/people-group-solid-blu.04ed47d7f0fd612bbdbacc92716652f1.svg";
export { ForwardRef as ReactComponent };